export const DONUT_DASHBOARD_MAX_SLICES = 10;
